import { clsx } from "clsx";
import { extendTailwindMerge } from "tailwind-merge";
import { twMergeConfig } from "@/ui/parserConfigs/plush/configs/tailwind-tw-merge.global.config";
const twMerge = extendTailwindMerge(twMergeConfig);
export function cn(...inputs) {
  return twMerge(clsx(inputs));
}
export function isDark(dark) {
  return dark ? "dark" : "light";
}
let scrollTop;
export function disableScroll() {
  const { body, documentElement } = document;
  const scrollbarWidth = window.innerWidth - documentElement.clientWidth;
  scrollTop = documentElement.scrollTop;
  body.style.top = `-${scrollTop}px`;
  body.style.paddingRight = `${scrollbarWidth}px`;
  body.classList.add("scroll-disabled");
}
export function enableScroll() {
  const { body, documentElement } = document;
  body.classList.remove("scroll-disabled");
  documentElement.scrollTop = scrollTop;
  body.style.removeProperty("top");
  body.style.removeProperty("padding-right");
}
export function pascalCase(input) {
  return input.split("-").map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()).join("");
}
